
import { SiriusServiceBase, SiriusDataService } from '@ibtech/sirius-angular-service';
import { Injectable } from "@angular/core";
import { ControlAppModel } from "../shared/models/shared.model";

@Injectable()
export class AuthService extends SiriusServiceBase {
    constructor() {
        super();
    }

    control(dataService: SiriusDataService, chn: string) {
        var app = new ControlAppModel();
        app.App = chn;
        var promise = dataService.post<boolean>("ControlApp", app).toPromise();
        promise.then((result) => {
            return result;
        });
        return promise;
    }

}
